import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  tooltip: {
    fontSize: 10,
  },
}));
